import { z } from 'zod';
const baseSchema = z.object({
    encounterDate: z.string().optional(),
    encounterPerformedBy: z.string().optional(),
    encounterType: z.string().optional(),
    encounterTypeSpecify: z.string().optional(),
    certifyDate: z.string().min(1, 'required'),
    medicalConditions: z.string().optional(),
    criteriaAA: z.boolean().optional(),
    criteriaAASpecify: z.string().optional(),
    criteriaAB: z.boolean().optional(),
    criteriaBA: z.boolean().optional(),
    criteriaBB: z.boolean().optional(),
    homeboundReasons: z.array(z.string()).optional(),
    skilledNursingCare: z.string().optional(),
    physicalTherapy: z.string().optional(),
    occupationalTherapy: z.string().optional(),
    speechTherapy: z.string().optional(),
    homeHealthAide: z.string().optional(),
    medicalSocialServices: z.string().optional(),
    telehealthServices: z.string().optional(),
});
export const faceToFaceValidationSchema = z.object({
    id: z.string(),
    data: z.preprocess((input, ctx) => {
        const payload = input;
        if (payload.criteriaAA && !payload.criteriaAASpecify) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please specify illness or injury',
                path: ['criteriaAASpecify'],
            });
        }
        return input;
    }, baseSchema),
});
